import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import '../styles/legal.css';

const Disclaimer = () => {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <Header />
      
      <section className="legal-hero">
        <div className="container">
          <h1 className="legal-title">Disclaimer</h1>
          <p className="legal-subtitle">Important information about Offer Lifetime#</p>
          <p className="legal-date">Last Updated: January 2025</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-card disclaimer-primary">
            <div className="legal-icon">
              <i data-lucide="alert-triangle"></i>
            </div>
            <h2>WE ARE NOT A SATTA/GAMBLING COMPANY</h2>
            <p className="disclaimer-highlight">
              <strong>Offer Lifetime#</strong> is NOT a Satta company, gambling platform, lottery service, or betting operation. 
              We are a legitimate business that issues VIP Tokens and conducts transparent prize distributions based on 
              fair and random selection processes.
            </p>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="award"></i> What We Do</h2>
            <p>
              Offer Lifetime# operates as a promotional and marketing platform that:
            </p>
            <ul>
              <li><strong>Issues VIP Tokens:</strong> We provide VIP Token Numbers to registered participants as part of our exclusive membership program.</li>
              <li><strong>Conducts Prize Draws:</strong> We organize regular prize draws where VIP Token holders have the opportunity to win gift money prizes.</li>
              <li><strong>Transparent Operations:</strong> All our processes are transparent, documented, and conducted in accordance with applicable laws and regulations.</li>
              <li><strong>Community Building:</strong> We focus on building a community of participants who engage with our brand and social media platforms.</li>
              <li><strong>Social Responsibility:</strong> We contribute to charitable causes, including the Army Fund, as part of our commitment to social welfare.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="x-circle"></i> What We Are NOT</h2>
            <ul>
              <li><strong>NOT a Satta Company:</strong> We do not operate any form of Satta, Matka, or illegal gambling activities.</li>
              <li><strong>NOT a Betting Platform:</strong> We do not facilitate betting, wagering, or any games of chance that involve monetary stakes.</li>
              <li><strong>NOT a Lottery Service:</strong> While we conduct prize draws, we are not a government-regulated lottery service.</li>
              <li><strong>NOT a Get-Rich-Quick Scheme:</strong> We do not promise guaranteed returns or winnings. Prize distribution is based on random selection.</li>
              <li><strong>NOT Involved in Illegal Activities:</strong> We operate within the legal framework and do not engage in any prohibited or illegal activities.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="shield-check"></i> Legal Compliance</h2>
            <p>
              Offer Lifetime# is committed to operating in full compliance with all applicable laws and regulations:
            </p>
            <ul>
              <li>We operate as a registered business entity in India.</li>
              <li>Our prize distribution model is based on promotional marketing activities, not gambling or betting.</li>
              <li>We maintain complete transparency in our operations and prize selection processes.</li>
              <li>We do not accept any form of betting or wagering from participants.</li>
              <li>VIP Token issuance is part of our membership program and promotional activities.</li>
              <li>All prize distributions are conducted fairly and in accordance with our published terms and conditions.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="info"></i> Nature of VIP Tokens</h2>
            <p>
              VIP Tokens issued by Offer Lifetime# are:
            </p>
            <ul>
              <li><strong>Membership Identifiers:</strong> VIP Tokens serve as unique identifiers for our members in our promotional program.</li>
              <li><strong>Not Financial Instruments:</strong> VIP Tokens are not securities, investments, or financial instruments of any kind.</li>
              <li><strong>Non-Transferable:</strong> VIP Tokens cannot be sold, transferred, or exchanged for cash except through official prize winnings.</li>
              <li><strong>Promotional Purpose:</strong> VIP Tokens are issued as part of our marketing and promotional activities to engage with our community.</li>
              <li><strong>No Guaranteed Returns:</strong> Holding a VIP Token does not guarantee any prize or return. Winners are selected randomly.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="users"></i> Participant Responsibility</h2>
            <p>
              By participating in Offer Lifetime#, you acknowledge and agree that:
            </p>
            <ul>
              <li>You understand this is a promotional program, not a gambling or betting platform.</li>
              <li>You are participating voluntarily and at your own discretion.</li>
              <li>You have read and understood our Terms and Conditions.</li>
              <li>You will not misrepresent our platform as a Satta, gambling, or betting service.</li>
              <li>You are responsible for complying with all applicable laws in your jurisdiction.</li>
              <li>You will not engage in any fraudulent or illegal activities related to our platform.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="alert-circle"></i> No Guarantees</h2>
            <ul>
              <li><strong>No Guaranteed Winnings:</strong> We do not guarantee that any participant will win a prize. Winners are selected through a random and fair process.</li>
              <li><strong>No Investment Returns:</strong> VIP Token issuance is not an investment, and participants should not expect any returns on their participation.</li>
              <li><strong>Service Availability:</strong> We do not guarantee uninterrupted access to our services and may modify or discontinue the program at any time.</li>
              <li><strong>Prize Amounts:</strong> While we strive to maintain our published prize structure, we reserve the right to modify prize amounts based on business considerations.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="scale"></i> Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law:
            </p>
            <ul>
              <li>Offer Lifetime# shall not be liable for any indirect, incidental, special, or consequential damages arising from your participation.</li>
              <li>We are not responsible for any technical issues, errors, or interruptions in service.</li>
              <li>We are not liable for any disputes between participants or third parties.</li>
              <li>Our total liability shall not exceed the value of the VIP Token associated with your account.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="heart"></i> Social Responsibility</h2>
            <p>
              Offer Lifetime# is committed to social responsibility:
            </p>
            <ul>
              <li>We contribute a portion of our earnings to the Army Fund to support our nation's heroes.</li>
              <li>We promote responsible participation and discourage any form of addiction or compulsive behavior.</li>
              <li>We maintain transparency in all our operations and prize distributions.</li>
              <li>We support community welfare initiatives and charitable causes.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="file-text"></i> Governing Law</h2>
            <p>
              This disclaimer and all related activities are governed by the laws of India. Any disputes shall be subject 
              to the exclusive jurisdiction of the courts in Kaithal, Haryana, India.
            </p>
          </div>

          <div className="legal-section">
            <h2><i data-lucide="mail"></i> Contact Us</h2>
            <p>
              If you have any questions or concerns about this disclaimer or our operations, please contact us:
            </p>
            <ul>
              <li>Email: support@offerlifetime.com</li>
              <li>Phone: +91 8818001860</li>
              <li>WhatsApp: +91 8818001860</li>
              <li>Address: VPO BATTA TH. KALAYAT, DISST. KAITHAL, HARYANA, INDIA-136117</li>
            </ul>
          </div>

          <div className="legal-card disclaimer-footer">
            <div className="legal-icon">
              <i data-lucide="check-circle"></i>
            </div>
            <h2>Acknowledgment</h2>
            <p>
              By using our services, you acknowledge that you have read and understood this disclaimer and agree to 
              participate in Offer Lifetime# with full knowledge that this is a promotional program and not a Satta, 
              gambling, or betting platform.
            </p>
          </div>

          <div className="legal-actions">
            <Link to="/" className="btn btn-secondary">Back to Home</Link>
            <Link to="/terms" className="btn btn-outline">Read Terms & Conditions</Link>
            <Link to="/register" className="btn btn-primary">Register Now</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Disclaimer;
